interface Props {
  stepNumber: number
  totalSteps: number
}

export function WizardStepPill({ stepNumber, totalSteps }: Props) {
  return (
    <span className="mb-2 inline-flex w-fit items-center rounded-full bg-ds2026-badge-primary-bg px-2 py-0.5 text-xs font-medium text-ds2026-badge-primary-text">
      Step {stepNumber} of {totalSteps}
    </span>
  )
}
